import { createContext, useContext, useState, useCallback } from 'react';

const ToastCtx = createContext({ toast: () => {} });

let nextId = 1;

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);

  const toast = useCallback((message, opts = {}) => {
    const id = nextId++;
    const variant = opts.variant || 'info'; // info | success | warning | danger
    const duration = opts.duration ?? 3500;
    setItems((arr) => [...arr, { id, message, variant }]);
    setTimeout(() => {
      setItems((arr) => arr.filter((t) => t.id !== id));
    }, duration);
  }, []);

  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div
        aria-live="polite"
        style={{
          position: 'fixed',
          right: 16,
          bottom: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          zIndex: 9999,
          pointerEvents: 'none',
        }}
      >
        {items.map((t) => (
          <div
            key={t.id}
            role="status"
            style={{
              minWidth: 260,
              maxWidth: 380,
              padding: '10px 14px',
              borderRadius: 'var(--radius-md)',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-color)',
              boxShadow: 'var(--shadow-lg)',
              color: 'var(--text-primary)',
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              animation: 'fadeIn .25s ease both',
              pointerEvents: 'auto',
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                background:
                  t.variant === 'success' ? 'var(--success)' :
                  t.variant === 'warning' ? 'var(--warning)' :
                  t.variant === 'danger'  ? 'var(--danger)'  : 'var(--accent-primary)',
              }}
            />
            <span style={{ flex: 1 }}>{t.message}</span>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
